import React, { useEffect, useState, useMemo } from 'react';
import { Wrap, Tab, TabButton, List, ListItem } from './styled';
import { ScoreDetailService } from 'services';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';

const BasketballBroadCast = observer(({ gameData }) => {
  const { detail } = gameData;
  const { period, teams } = detail;

  const { id } = useParams();
  const [totalItem, setTotalItem] = useState({});
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    ScoreDetailService.getBroadcastsBySportsType('basketball', id).then((res) => {
      setTotalItem(res);
      let items = [];
      for (let item of Object.values(res).reverse()) {
        items = items.concat(item);
      }
      setItems(items);
    });
  }, []);

  useEffect(() => {
    if (active === 0) {
      let items = [];
      for (let item of Object.values(totalItem).reverse()) {
        items = items.concat(item);
      }
      setItems(items);
    } else {
      setItems(totalItem[active] || []);
    }
  }, [active]);
  const newItems = [...items].reverse().filter((item) => item.eventType === 'GOAL');

  return (
    <Wrap>
      <Tab>
        <div>
          <TabButton active={active === 0} onClick={() => setActive(0)} disabled={false}>
            전체
          </TabButton>
          <TabButton active={active === 1} onClick={() => setActive(1)} disabled={period < 1}>
            1쿼터
          </TabButton>
          <TabButton active={active === 2} onClick={() => setActive(2)} disabled={period < 2}>
            2쿼터
          </TabButton>
          <TabButton active={active === 3} onClick={() => setActive(3)} disabled={period < 3}>
            3쿼터
          </TabButton>
          <TabButton active={active === 4} onClick={() => setActive(4)} disabled={period < 4}>
            4쿼터
          </TabButton>
          <TabButton active={active === 5} onClick={() => setActive(5)} disabled={period < 5}>
            연장
          </TabButton>
        </div>
      </Tab>
      <List>
        {newItems.length > 0 ? (
          newItems.map((item, key) => {
            const prevScore = newItems[key - 1] ?? { score: { home: 0, away: 0 } };
            return <Item key={key} item={item} prevScore={prevScore} />;
          })
        ) : (
          <ListItem>
            <span className='no-data'>데이터가 없습니다.</span>
          </ListItem>
        )}
      </List>
    </Wrap>
  );
});

const calculateDiff = (prevHome, prevAway, home, away) => {
  const currentDiff = (home ?? 0) - (away ?? 0);
  const prevDiff = (prevHome ?? 0) - (prevAway ?? 0);

  let homeDisplay = 0;
  let awayDisplay = 0;
  let homeColor = '';
  let awayColor = '';

  if (currentDiff > 0) {
    homeDisplay = currentDiff;
    homeColor = currentDiff > prevDiff ? 'up' : currentDiff < prevDiff ? 'down' : '';
  } else if (currentDiff < 0) {
    awayDisplay = Math.abs(currentDiff);
    awayColor = currentDiff < prevDiff ? 'up' : currentDiff > prevDiff ? 'down' : '';
  }

  return {
    homeDisplay,
    awayDisplay,
    homeColor,
    awayColor,
  };
};

const Item = ({ item, prevScore }) => {
  const { homeDisplay, awayDisplay, homeColor, awayColor } = calculateDiff(
    prevScore.score.home,
    prevScore.score.away,
    item.score.home,
    item.score.away
  );

  const styleClass = useMemo(() => {
    return {
      styleHomeScore: item.score.home > prevScore.score.home ? 'up' : '',
      styleAwayScore: item.score.away > prevScore.score.away ? 'up' : '',
    };
  }, [item.score.home, item.score.away, prevScore.score.home, prevScore.score.away]);

  return (
    <ListItem>
      <div className='score-container home'>
        {homeDisplay > 0 && <span className={`diff ${homeColor}`}>{`+${homeDisplay}`}</span>}
        <span className={styleClass.styleHomeScore}>{item.score.home || 0}</span>
      </div>
      <div className='score-container'>
        <span className='separator'>-</span>
      </div>
      <div className='score-container away'>
        <span className={styleClass.styleAwayScore}>{item.score.away || 0}</span>
        {awayDisplay > 0 && <span className={`diff ${awayColor}`}>{`+${awayDisplay}`}</span>}
      </div>
    </ListItem>
  );
};

export default BasketballBroadCast;
